module.exports = __webpack_public_path__ + "static/control-system-15c370f736c2f5b6042a766750fe155c.png";